import React, { useEffect, useState } from "react";
import "./sideBar.css";
import navList from "../data/navItem";
import NavItem from "./Dashboard/NavItem";
import { useAuthStore } from "../../../store/store";
import { HasPermission, HasSubSectionPermission } from "./auth";

function SideBar() {
  const [filteredSections, setFilteredSections] = useState([]);

  const { sectionId, subSection } = useAuthStore((state) => state.status);
  const setSectionId = useAuthStore((state) => state.setSectionId);

  useEffect(() => {
    // This will only run on initial render
    //  useState(navList[0]?._id ?? 0);

    // validate
    //  const { sectionId, subSection } = useAuthStore((state) => {
    const subSectionId = subSection?._id ?? null;

    const copyNavList = JSON.parse(JSON.stringify(navList));

    const filteredSections = copyNavList
      .flatMap((nav) => {
        let hasPermission = HasPermission(nav._id, ["ver"]);
        if (!hasPermission) {
          return null;
        }

        //  const isSelected = nav._id === sectionId;
        if (nav.subs != null && nav.subs.length > 0) {
          const testSubs = nav.subs.filter((sub, index) => {
            return HasSubSectionPermission(nav._id, sub.remoteid, ["ver"]);
          });
          nav.subs = testSubs;
        }

        return { nav, subSectionId };
      })
      .filter((value) => value);

    setFilteredSections(filteredSections);

    // has a default selection?
    const hasSelection = filteredSections.find(
      (item) => item.nav._id === sectionId
    );
    if (hasSelection) {
      //esta activa la seccion, ahora checar subseccion
      const hasSubSelection = hasSelection.nav?.subs?.find(
        (item) => item._id === subSectionId
      );

      if (!hasSubSelection) {
        /*let newSubSection = null;
        if (hasSelection?.nav?.subs?.length > 0) {
          newSubSection = hasSelection.nav.subs[0];
        }*/
        handleSectionChange(hasSelection.nav, null);
      } else {
        //subseccion no existe
        // no esta activa la seccion
        let newSection = null;
        if (filteredSections.length > 0) {
          newSection = filteredSections[0].nav;
        }

        handleSectionChange(newSection, null);
      }
    } else {
      // no esta activa la seccion
      let newSection = null;
      if (filteredSections.length > 0) {
        newSection = filteredSections[0].nav;
      }

      handleSectionChange(newSection, null);
    }
  }, []);

  const handleSectionChange = (item, sub) => {
    /*  const { setSectionId } = useStore((state) => ({
      setSectionId: state.setSectionId,
    }));*/
    //  setSelectedId(item._id);
    //  setSectionId(item._id);
    if (item == null) return;

    let nextSub = sub;
    if (item.subs?.length > 0 && sub == null) {
      nextSub = item.subs[0];
    }
    setSectionId(item._id, nextSub);
  };

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-heading">Secciones</li>
        {filteredSections.map((item, index) => {
          const isSelected = item.nav._id === sectionId;
          const subSectionId = subSection?._id ?? null;
          const nav = item.nav;

          return (
            <>
              <NavItem
                key={index}
                nav={nav}
                isSelected={isSelected}
                subSectionId={subSectionId}
                onClick={handleSectionChange}
              />
            </>
          );
        })}
      </ul>
    </aside>
  );
}

export default SideBar;
